import { safeStorage } from './safe-storage';

/**
 * 判断是否为iOS设备
 * @param userAgent 用户代理字符串
 * @returns 是否为iOS设备
 */
export const isIOS = (): boolean => {
  if (typeof window === 'undefined') return false;
  return /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
};

/**
 * 判断是否为Android设备
 * @param userAgent 用户代理字符串
 * @returns 是否为Android设备
 */
export const isAndroid = (): boolean => {
  if (typeof window === 'undefined') return false;
  return /android/.test(window.navigator.userAgent.toLowerCase());
};

/**
 * 存储 HEVC 不支持状态的 key
 */
const HEVC_NOT_SUPPORTED_KEY = 'VIDU_HEVC_NOT_SUPPORTED';

/**
 * 判断是否支持HEVC(H.265)
 * @returns 是否支持HEVC
 */
export const isHevcSupported = (): boolean => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;

  // 检查 safeStorage 中是否有记录该设备不支持 HEVC
  if (safeStorage.getItem(HEVC_NOT_SUPPORTED_KEY) === 'true') {
    return false;
  }

  // 优先使用 MediaSource API 检测（适用于支持 MediaSource 的浏览器）
  const MediaSource = window.MediaSource || window.WebKitMediaSource;
  if (MediaSource?.isTypeSupported) {
    return (
      MediaSource.isTypeSupported('video/mp4;codecs="hev1.1.6.L120.90"') ||
      MediaSource.isTypeSupported('video/mp4;codecs="hev1.2.4.L120.90"') ||
      MediaSource.isTypeSupported('video/mp4;codecs="hev1.3.E.L120.90"') ||
      MediaSource.isTypeSupported('video/mp4;codecs="hev1.4.10.L120.90"')
    );
  }

  // 如果 MediaSource 不可用（如 iPhone），使用 video 元素的 canPlayType 方法
  const video = document.createElement('video');
  const supportLevel = video.canPlayType('video/mp4;codecs="hvc1"');
  // 只判断 'probably'，因为 'maybe' 表示不确定，实际播放可能失败
  return supportLevel === 'probably';
};

/**
 * 记录当前设备不支持 HEVC
 */
export const markHevcNotSupported = (): void => {
  safeStorage.setItem(HEVC_NOT_SUPPORTED_KEY, 'true');
};
